// import bus from './bus.js';
var myfunction = {
  mytoFixed: function (number, fractionDigits) {
    let times = Math.pow(10, fractionDigits)
    let roundNum = Math.round(number * times) / times
    let a = roundNum.toFixed(fractionDigits)
    console.log(a)
    return a
  },
  mytoFixedFloor: function (number) {
    let a = Math.floor(number)
    console.log(a)
    return a
  },
  checkNumber(number) {
    let numReg = /^[0-9]*$/
    let numRe = new RegExp(numReg)
    if (!numRe.test(number)) {
      return false
    } else {
      return true
    }
  },
  // export2Excel: function(columns, list, exclefilename) {
  // 	require.ensure([], () => {
  // 		const {
  // 			export_json_to_excel
  // 		} = require('./excel/Export2Excel');
  // 		let tHeader = [];
  // 		let filterVal = [];
  // 		columns.forEach(item => {
  // 			tHeader.push(item.title);
  // 			filterVal.push(item.key);
  // 		})
  // 		const data = list.map(v => filterVal.map(j => v[j]));
  // 		export_json_to_excel(tHeader, data, exclefilename);
  // 	})
  // },
  // importExe: function(event, mythis, callBack) {
  // 	if (!event.target.files.length) {
  // 		return;
  // 	}
  // 	const that = mythis;
  // 	// 拿取文件对象
  // 	var f = event.target.files[0];
  // 	// 用FileReader来读取
  // 	var reader = new FileReader();
  // 	// 重写FileReader上的readAsBinaryString方法
  // 	FileReader.prototype.readAsBinaryString = function(f) {
  // 		var binary = '';
  // 		var wb; // 读取完成的数据
  // 		var outdata; // 你需要的数据
  // 		var reader = new FileReader();
  // 		reader.onload = function(e) {
  // 			// 读取成Uint8Array，再转换为Unicode编码（Unicode占两个字节）
  // 			var bytes = new Uint8Array(reader.result);
  // 			var length = bytes.byteLength;
  // 			for (var i = 0; i < length; i++) {
  // 				binary += String.fromCharCode(bytes[i]);
  // 			}
  // 			// 接下来就是xlsx了，具体可看api
  // 			var XLSX = require('xlsx');
  // 			wb = XLSX.read(binary, {
  // 				type: 'binary'
  // 			});
  // 			outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
  // 			// 自定义方法向父组件传递数据
  // 			console.log('outdata = ' + JSON.stringify(outdata));
  // 			callBack(mythis, outdata);
  // 		}
  // 		reader.readAsArrayBuffer(f);
  // 	}
  // 	reader.readAsBinaryString(f);
  // },
  formatDate: function (numb) {
    const time = new Date((numb - 1) * 24 * 3600000 + 1)
    time.setYear(time.getFullYear() - 70)
    return time
  },
  showtip: function (pageContent, content) {
    pageContent.$alert(content, pageContent.$t('common.tip'), {
      confirmButtonText: pageContent.$t('confirm'),
    })
  },
  showtipMessage: function (pageContent, content, types, useHTML) {
    pageContent.$message({
      message: content,
      type: types,
      dangerouslyUseHTMLString: useHTML ? useHTML : false, // 是否允许使用HTML
    })
  },
  showtipNoNullMessage: function (pageContent, head) {
    pageContent.$message({
      message: head + pageContent.$t('cannotBeEmpty'),
      type: 'warning',
    })
  },
  showNoPermissions: function (pageContent) {
    pageContent.$message({
      message: pageContent.$t('permissionDenied'),
      type: 'warning',
    })
  },
  addStr: function (old, str) {
    if (old == '') {
      return str
    } else {
      return old + ',' + str
    }
  },
  DatetoStrNoTimeZone: function (data, formats) {
    return data.format(formats)
  },

  ///yyyyMMddHHmmss
  formatDate(dateString) {
    // 从输入的字符串中提取年、月、日、时、分、秒
    const year = dateString.substring(0, 4)
    const month = dateString.substring(4, 6) - 1 // 月份是从0开始的
    const day = dateString.substring(6, 8)
    const hour = dateString.substring(8, 10)
    const minute = dateString.substring(10, 12)
    const second = dateString.substring(12, 14)

    // 创建日期对象
    const date = new Date(year, month, day, hour, minute, second)

    // 格式化为 "yyyy-MM-dd HH:mm:ss"
    const formattedDate = date.toISOString().replace('T', ' ').substring(0, 19)

    return formattedDate
  },

  get00Date: function (data) {
    var date2 = new Date(
      data.getTime() - ((data.getTime() - data.getTimezoneOffset() * 60000) % (1000 * 60 * 60 * 24))
    )
    return date2
  },
  getDate: function (data) {
    var date2 = new Date(data.getTime() - data.getTimezoneOffset() * 60000)
    return date2
  },
  /**
   * @param {Object} data
   * 获取当天23：59：59的时间
   */
  getdayLastTimeDate: function (data) {
    var date2 = new Date(
      data.getTime() - ((data.getTime() - data.getTimezoneOffset() * 60000) % (1000 * 60 * 60 * 24))
    )
    date2.setHours(23)
    date2.setMinutes(59)
    date2.setSeconds(59)
    return date2
  },
  /**
   * @param {Object} Seconds 秒
   * 根据秒数获取天时分秒
   */
  getTimeDHMS: function (Seconds, ss) {
    var d = parseInt(Seconds / 86400)
    var s = parseInt(Seconds % 86400)
    var h = parseInt(s / 3600)
    s = s % 3600
    var m = parseInt(s / 60)
    s = s % 60
    var str = ''
    if (d > 0) {
      str += d + ss[0]
    }
    if (h > 0) {
      str += ' ' + h + ss[1]
    }
    if (m > 0) {
      str += ' ' + m + ss[2]
    }
    if (s > 0) {
      str += ' ' + s + ss[3]
    }
    return str === '' ? 'N/A' : str
  },
  file2Bytes: function (file, callBack) {
    var reader = new FileReader()
    //设置一个回调函数，等待读取结束后调用
    reader.onload = function (e) {
      var data = e.target.result
      //showbox.style.backgroundImage = 'url(' + data + ')';
      callBack(data)
    }
    //以url方式读取文件
    reader.readAsDataURL(file)
  },
  base64ToUint8Array: function (base64String) {
    let padding = '='.repeat((4 - (base64String.length % 4)) % 4)
    let base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/')
    let rawData = window.atob(base64)
    let outputArray = new Uint8Array(rawData.length)
    for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
  },
  stringToByte: function (str) {
    var bytes = new Array()
    var len, c
    len = str.length
    for (var i = 0; i < len; i++) {
      c = str.charCodeAt(i)
      if (c >= 0x010000 && c <= 0x10ffff) {
        bytes.push(((c >> 18) & 0x07) | 0xf0)
        bytes.push(((c >> 12) & 0x3f) | 0x80)
        bytes.push(((c >> 6) & 0x3f) | 0x80)
        bytes.push((c & 0x3f) | 0x80)
      } else if (c >= 0x000800 && c <= 0x00ffff) {
        bytes.push(((c >> 12) & 0x0f) | 0xe0)
        bytes.push(((c >> 6) & 0x3f) | 0x80)
        bytes.push((c & 0x3f) | 0x80)
      } else if (c >= 0x000080 && c <= 0x0007ff) {
        bytes.push(((c >> 6) & 0x1f) | 0xc0)
        bytes.push((c & 0x3f) | 0x80)
      } else {
        bytes.push(c & 0xff)
      }
    }
    return bytes
  },
  byteToString: function (arr) {
    if (typeof arr === 'string') {
      return arr
    }
    var str = '',
      _arr = arr
    for (var i = 0; i < _arr.length; i++) {
      var one = _arr[i].toString(2),
        v = one.match(/^1+?(?=0)/)
      if (v && one.length == 8) {
        var bytesLength = v[0].length
        var store = _arr[i].toString(2).slice(7 - bytesLength)
        for (var st = 1; st < bytesLength; st++) {
          store += _arr[st + i].toString(2).slice(2)
        }
        str += String.fromCharCode(parseInt(store, 2))
        i += bytesLength - 1
      } else {
        str += String.fromCharCode(_arr[i])
      }
    }
    return str
  },
  StringToHtml: function (str) {
    str = str.replace(/ /g, '+')
    str = str.replace(/%/g, '%25')
    return str
  },
  // goBack: function(pageContent) {
  // 	//pageContent.$router.push('/');
  // 	bus.$emit('close_current_tags');
  // },
  noSearchPermissions: function (vm) {
    myfunction.showNoPermissions(vm)
    return '/workbench'
  },
  log: function (...args) {
    console.log(args)
  },
  // closeNow: function() {
  // 	bus.$emit('close_current_tags');
  // },
  //经纬度校验
  verifylonglat: function (page, longitude, latitude) {
    //经度，整数部分为0-180小数部分为6位
    var longreg =
      /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{6}|180)$/
    if (!longreg.test(longitude)) {
      page.$message({
        message: pageContent.$t('longitudeRule'),
        type: 'warning',
      })
      return false
    }
    //纬度,整数部分为0-90小数部分为6位
    var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{6}|90\.0{6}|[0-8]?\d{1}|90)$/
    if (!latreg.test(latitude)) {
      page.$message({
        message: pageContent.$t('latitudeRule'),
        type: 'warning',
      })
      return false
    }
    return true
  },
  //表格文本操作相关
  /**
   * @param {String} key	要对比的字段
   * @param {String} targetKey 目标字段
   * @param {String} fixed  对齐，left还是right
   */
  getFixed: function (key, targetKey, fixed) {
    return key === targetKey ? fixed : ''
  },
  /**
   * @param {Object} bool
   * @param {String} trueStr   true时的文本
   * @param {String} falseStr false时的文本
   */
  replaceStrByBool: function (bool, trueStr, falseStr) {
    return bool === true ? trueStr : bool === false ? falseStr : bool
  },
  /**
   * @param {Object} a 数据1
   * @param {Object} b 数据2
   * @param {String} x 字段
   * @param {Object} params  排序的值
   */
  tableSort: function (a, b, x, params) {
    if (a[x] === undefined) {
      return -1
    } else if (b[x] === undefined) {
      return 1
    }

    const dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/

    if (dateTimePattern.test(a[x]) && dateTimePattern.test(b[x])) {
      let dateA = new Date(a[x])
      let dateB = new Date(b[x])

      if (params[x] === 'asc') {
        return dateA - dateB
      } else if (params[x] === 'desc') {
        return dateB - dateA
      }
    } else if (typeof a[x] == 'string' && typeof b[x] == 'string') {
      if (params[x] === 'asc') {
        return a[x].localeCompare(b[x])
      } else if (params[x] === 'desc') {
        return b[x].localeCompare(a[x])
      }
    } else {
      if (params[x] === 'asc') {
        return a[x] - b[x]
      } else if (params[x] === 'desc') {
        return b[x] - a[x]
      }
    }
  },
  /**
   * 获取日期相差天数
   * @param start 2019-01-21
   * @param end 2019-01-23
   */
  getDays: function (start, end) {
    let dateSpan, iDays
    start = Date.parse(start)
    end = Date.parse(end)
    dateSpan = end - start
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000))
    return iDays
  },

  /**
   *使用递归的方式实现数组、对象的深拷贝
   *
   * @returns
   */
  deepClone: function (obj) {
    var target = {}
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        if (typeof obj[key] === 'object') {
          target[key] = deepClone(obj[key])
        } else {
          target[key] = obj[key]
        }
      }
    }
    return target
  },
  // 获取当前时间 格式为 yyyy-MM-dd HH:mm:ss
  getFormattedDateTime: function () {
    let currentDate = new Date()

    // 获取一个月前的时间
    let lastMonthDate = new Date(currentDate)
    // lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)

    // 格式化日期
    function formatDate(date) {
      let year = date.getFullYear()
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let day = date.getDate().toString().padStart(2, '0')
      let hours = date.getHours().toString().padStart(2, '0')
      let minutes = date.getMinutes().toString().padStart(2, '0')
      let seconds = date.getSeconds().toString().padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }

    let currentDateFormatted = formatDate(currentDate)
    // let lastMonthDateFormatted = formatDate(lastMonthDate)
    return currentDateFormatted
  },
  getFormattedDateTime1: function () {
    let currentDate = new Date()

    currentDate.setDate(currentDate.getDate() + 1)
    // 获取一个月前的时间
    let lastMonthDate = new Date(currentDate)
    // lastMonthDate.setMonth(lastMonthDate.getMonth() - 1)

    // 格式化日期
    function formatDate(date) {
      let year = date.getFullYear()
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let day = date.getDate().toString().padStart(2, '0')
      let hours = date.getHours().toString().padStart(2, '0')
      let minutes = date.getMinutes().toString().padStart(2, '0')
      let seconds = date.getSeconds().toString().padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }

    let currentDateFormatted = formatDate(currentDate)
    // let lastMonthDateFormatted = formatDate(lastMonthDate)
    return currentDateFormatted
  },
  /**
   *
   * @param { Function } callback
   * @param {轮询间隔} interval
   * @returns
   */
  pollFn: function (callback, interval = 1000) {
    let timerId
    //是否停止轮询
    let isStop = false
    //轮询请求
    const pollFetch = async () => {
      await callback()
      if (isStop) return
      // let randomNum = Math.random() * 10;

      // // 映射到-3至3之间的范围
      // let result = randomNum - 5;
      // interval = interval + result * 1000;
      timerId = setTimeout(pollFetch, interval)
      return
    }
    //开始轮询
    const start = async () => {
      await pollFetch()
    }
    //停止轮询
    const stop = () => {
      isStop = true
      clearTimeout(timerId)
    }
    return {
      start,
      stop,
    }
  },
}
Date.prototype.format = function (format) {
  var o = {
    'M+': this.getMonth() + 1, //month
    'd+': this.getDate(), //day
    'h+': this.getHours(), //hour
    'm+': this.getMinutes(), //minute
    's+': this.getSeconds(), //second
    'q+': Math.floor((this.getMonth() + 3) / 3), //quarter
    S: this.getMilliseconds(), //millisecond
  }
  if (/(y+)/.test(format))
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o)
    if (new RegExp('(' + k + ')').test(format))
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return format
}
export default myfunction
